import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { WhatsappQr } from "./pages/WhatsappQr";
import { WhatsappOficial } from "./pages/WhatsappOficial";
import { Sms } from "./pages/Sms";
import { Pricing } from "./pages/Pricing";

function ScrollToTop() {
  const { pathname } = useLocation();
  // Bug real encontrado: escrito antes como "useEffect(() => window.scrollTo(0, 0), [pathname])"
  // (corpo em expressao) - isso faz o efeito RETORNAR o que window.scrollTo devolver, em vez de
  // garantir undefined. O React tenta chamar esse retorno como funcao de limpeza no proximo
  // efeito ("destroy is not a function"), quebrando bem no fundo do scheduler/commit do React -
  // exatamente o "TypeError: n is not a function" sem nenhuma linha do nosso codigo no stack
  // trace, reproduzido de forma 100% consistente so no Chrome. Corpo em bloco garante que o
  // efeito nunca retorna nada.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ErrorBoundary>
        <div className="flex min-h-screen flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/whatsapp-web" element={<WhatsappQr />} />
              <Route path="/whatsapp-oficial" element={<WhatsappOficial />} />
              <Route path="/sms" element={<Sms />} />
              <Route path="/planos" element={<Pricing />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
